import { Icons } from '@/components/Shares/Icons';
import { useTheme } from '@/theme/useTheme';
import { useLingui } from '@lingui/react';
import { Switch, Text, rem } from '@mantine/core';
import { IconSun } from '@tabler/icons-react';
import classes from './Preference.module.css';
export const ThemeSwitch: React.FC = () => {
  const {
    setColorScheme,
    colorScheme
  } = useTheme();
  const {
    i18n
  } = useLingui();
  const sunIcon = <IconSun style={{
    width: rem(16),
    height: rem(16)
  }} stroke={2.5} color="var(--mantine-color-yellow-6)" />;
  const moonIcon = <Icons className="icon-pr-flat-moon-stars" fontSize={16} color="var(--text-dark)" />;
  return <Switch defaultChecked size="xl" w={{
    base: 82,
    sm: 98
  }} onLabel={<Text fz={rem(10)} c="var(--text-dark)" fw={700}>
          {i18n._('DARK')}
        </Text>} offLabel={<Text fz={rem(10)} fw={700}>
          {i18n._('LIGHT')}
        </Text>} color="var(--bg-100)" value={colorScheme} classNames={{
    track: classes.track,
    thumb: colorScheme === 'dark' ? classes.thumbDark : classes.thumbLight
  }} onChange={value => setColorScheme(value.target.checked ? 'dark' : 'light')} thumbIcon={colorScheme === 'dark' ? moonIcon : sunIcon} />;
};